import React from 'react';
import './style.css';

const StickySelectionBar = ({ selectedProductsByKeyword, onSubscribe, onClear, isLoading = false }) => {
  const keywordGroups = Object.keys(selectedProductsByKeyword);

  if (keywordGroups.length === 0) {
    return null;
  }

  const getTotalCount = () => {
    return Object.values(selectedProductsByKeyword).reduce((total, products) => total + products.length, 0);
  };

  return (
    <div className="sticky_selection_bar">
      <div className="selection_bar_content">
        <div className="selection_info">
          <div className="selection_summary">
            <div className="total_selection_count">
              {getTotalCount()} product{getTotalCount() > 1 ? 's' : ''} selected

              {/* Info icon + tooltip (added) */}
              <span className="info_icon_wrapper" aria-label="Selection help">
                <span className="info_icon">i</span>
                <span className="info_tooltip">
                  Please assign the correct category to sell these products on Shopify, Amazon, and other marketplaces.
                </span>
              </span>
            </div>

            <div className="keyword_groups">
              {keywordGroups.map((keyword, index) => {
                const products = selectedProductsByKeyword[keyword];
                return (
                  <div key={keyword} className="keyword_group_item">
                    <span className="keyword_badge">
                      {products.length} for "{keyword}"
                    </span>
                    {index < keywordGroups.length - 1 && <span className="keyword_separator">•</span>}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div className="selection_actions">
          <button
            className="clear_btn_multi"
            onClick={onClear}
            disabled={isLoading}
            title="Clear all selections"
          >
            Clear
          </button>
          <button
            className="subscribe_btn_multi"
            onClick={onSubscribe}
            disabled={isLoading || getTotalCount() === 0}
          >
            {isLoading ? 'Processing...' : 'Subscribe Now'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default StickySelectionBar;
